import React, { Fragment } from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import CardBlog from '../../component/Other/CardBlog'
import SecContact from '../../component/Page/SecContact'

const BlogDetail = () => {
    const blogData = [
        {
            tag: "Plant Care",
            bg: "./../images/bg (3).png",
            title: "The Importance of Soil Quality for Healthy Plant Growth",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
        {
            tag: "Design and Decor",
            bg: "./../images/bg (1).png",
            title: "The Best Plants for Hanging Baskets: A Guide to Elevated Greenery",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
        {
            tag: "Design and Decor",
            bg: "./../images/bg (2).png",
            title: "How to Incorporate Plants into Your Home Office for a Productivity Boost",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
    ]
    return (
        <Fragment>
            <div className="overflow-hidden position-relative">
                <img src="./../images/sasa (1).png" className='images__leaf-det-1' alt="" />
                <img src="./../images/sasa (2).png" className='images__leaf-det-2' alt="" />

                <Navbar />

                <section className="position-relative">
                    <div className="container">

                        <p className='medium font__size--16 text__16-1024 color__gray-1 mb-5'><span className='color__orange'>Home  / Our Blog</span> / The Benefits of Indoor Plants for Your Health and Well-Being </p>

                        <div className="row justify-content-center">
                            <div className="col-md-9">

                                <div className="text-center">
                                    <div className="wrapper__tag-line semi-bold font__size--16 text__16-1024">
                                        Green Living
                                    </div>

                                    <h2 className='normal font__size--64 text__65-1024 text__65-sm text__65-xxs mb-4'>The Benefits of Indoor Plants for Your Health and Well-Being</h2>

                                    <div className="wrapper__profile text-left">
                                        <img src="./../images/Image (1).png" alt="" />
                                        <div className="desc ml-2">
                                            <h5 className="semi-bold font__size--16 text__16-1024 mb-0">By Arka</h5>
                                            <p className="mb-0 normal font__size--12 text__12-1024 color__gray-1">Just now</p>
                                        </div>
                                    </div>
                                </div>

                                <img src="./../images/Bg.png" className='images__detail-blog my-5' alt="" />


                                <p className='semi-bold font__size--24 text__24-1024 color__gray-1 mb-4'>Indoor plants can do more than just add a touch of green to your home or office. They can actually improve your physical and mental health. Here are some of the many benefits of indoor plants:</p>

                                <div className="mb-4">
                                    <h5 className='semi-bold font__size--24 text__24-1024'>1.Purifying the Air</h5>
                                    <p className='normal font__size--20 text__20-1024'>Indoor plants can help to purify the air in your home or office. They absorb harmful chemicals and pollutants, and release oxygen into the air. Some of the best plants for air purification include spider plants, peace lilies, and Boston ferns.</p>
                                </div>

                                <div className="mb-4">
                                    <h5 className='semi-bold font__size--24 text__24-1024'>2. Boosting Mood and Productivity</h5>
                                    <p className='normal font__size--20 text__20-1024'>Indoor plants can also have a positive effect on your mood and productivity. Studies have shown that simply being around plants can lower stress levels, reduce anxiety, and improve mood. In addition, having plants in your workspace can increase productivity, creativity, and overall job satisfaction.</p>
                                </div>

                                <div className="mb-4">
                                    <h5 className='semi-bold font__size--24 text__24-1024'>3. Improving Mental Health</h5>
                                    <p className='normal font__size--20 text__20-1024'>Indoor plants can be beneficial for those struggling with mental health issues such as depression and anxiety. The act of caring for plants can provide a sense of purpose and accomplishment, and can help to reduce symptoms of depression and anxiety.</p>
                                </div>

                                <div className="mb-4">
                                    <h5 className='semi-bold font__size--24 text__24-1024'>4. Enhancing Physical Health</h5>
                                    <p className='normal font__size--20 text__20-1024'>In addition to their mental health benefits, indoor plants can also have physical health benefits. Some studies have shown that plants can lower blood pressure and improve respiratory function. Additionally, having plants in your home or office can reduce the risk of headaches and other symptoms associated with poor indoor air quality.</p>
                                </div>

                                <div className="mb-4">
                                    <h5 className='semi-bold font__size--24 text__24-1024'>5. Boosting Immune System</h5>
                                    <p className='normal font__size--20 text__20-1024'>Plants release phytoncides that help to boost our immune system. Exposure to these compounds can help to reduce stress levels and increase the production of white blood cells, which can help to fight off infections.</p>
                                </div>

                                <p className='normal font__size--20 text__20-1024 mb-5'>In conclusion, indoor plants can have a wide range of benefits for both your physical and mental health. Whether you choose to add a few plants to your home or office, or create an entire indoor garden, you're sure to notice the positive effects that plants can have on your well-being.</p>

                                <h5 className='semi-bold font__size--20 text__20-1024'>Share</h5>
                                <div className="d-flex align-items-center">
                                    <a href="#!" className='d-inline-block mr-3'>
                                        <img src="./../images/asa (1).png" alt="" />
                                    </a>
                                    <a href="#!" className='d-inline-block mr-3'>
                                        <img src="./../images/asa (2).png" alt="" />
                                    </a>
                                    <a href="#!" className='d-inline-block mr-3'>
                                        <img src="./../images/asa (3).png" alt="" />
                                    </a>
                                    <a href="#!" className='d-inline-block mr-3'>
                                        <img src="./../images/asa (4).png" alt="" />
                                    </a>
                                </div>

                            </div>
                        </div>

                    </div>
                </section>

                <section className='pt-0 mb-5'>
                    <div className="container">
                        <div className="text-center mb-5">
                            <h3 className='normal font__size--50 text__50-1024 text__50-sm text__50-xs quest'>Relate Blog</h3>
                            <p className="normal font__size--14 text__14-1024 color__gray-1">Our blog is filled with informative and inspiring content on all things green. From plant care tips and advice to the latest trends in gardening and <br className='d-none d-lg-block' /> design, our experts share their knowledge to help you bring your indoor and outdoor spaces to life.</p>
                        </div>

                        <div className="row">
                            {
                                blogData.map((obj) => {
                                    return <div className="col-md-6 col-lg-4 mb-4 mb-lg-0">
                                        <CardBlog data={obj} />
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </section>

                <SecContact />

                <Footer />
            </div >
        </Fragment >
    )
}

export default BlogDetail